/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLogout = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M12 5H4v14h8v2H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h8z" /><path fill="currentColor" d="M15.6 8.4 17 7l5 5-5 5-1.4-1.4 2.6-2.6H8v-2h10.2z" /></svg>;
export default SvgLogout;